import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { Component } from 'react';
import { propArrayShape, propFunc, propNumber, propShape, } from '../../../helpers/custom-prop-types';
import Image from '../../Ui/Common/Image';
import PdfImageModal from '../../Ui/Modal/Pdf/PdfImageModal';
import CustomSlider from '../../Ui/Slider';
import SlideModeFavoriteComponent from './SlideModalFavoriteComponent';
import SlideOneShowDescription from './SlideOneShowDescription';
class SlideOneShow extends Component {
    constructor(props) {
        super(props);
        this.getSlickConfig = (pages, initialPageNo) => ({
            adaptiveHeight: true,
            arrows: true,
            beforeChange: this.onBeforeChange,
            infinite: true,
            initialSlide: this.getEnablePage(pages, initialPageNo),
            responsive: [
                {
                    breakpoint: 768,
                    settings: {
                        arrows: false,
                        dots: true,
                        slidesToShow: 1,
                    },
                },
            ],
            slidesToShow: 1,
        });
        this.getEnablePage = (pages, pageNo) => {
            const initialSlide = pageNo - 1;
            return Math.max(pages.length < initialSlide ? 0 : initialSlide, 0);
        };
        this.onBeforeChange = (oldIndex, newIndex) => {
            this.setState({ pageNo: newIndex });
        };
        const { pageNo, pages } = this.props;
        this.state = {
            pageNo: this.getEnablePage(pages, pageNo),
            slickConfig: this.getSlickConfig(pages, pageNo),
        };
    }
    shouldComponentUpdate(nextProps) {
        const { pageNo, pages } = this.props;
        if (pages !== nextProps.pages || pageNo !== nextProps.pageNo) {
            this.setState({
                pageNo: this.getEnablePage(pages, pageNo),
                slickConfig: this.getSlickConfig(pages, pageNo),
            });
            return false;
        }
        return true;
    }
    render() {
        const { onClickCopy, onClickShow, onClickSlideClip, pages, slideFavoriteMap, } = this.props;
        const { pageNo, slickConfig } = this.state;
        const page = pages[pageNo];
        return (_jsxs("div", Object.assign({ className: 'search_slide_body_content' }, { children: [_jsxs("div", Object.assign({ className: 'search_slide_body_content_one' }, { children: [_jsx(CustomSlider, Object.assign({ className: 'search_slide_body_content_one_image', config: slickConfig }, { children: pages.map((mapPage) => (_jsx(Image, { alt: '', src: mapPage.image }, mapPage.id))) })), _jsx(SlideOneShowDescription, { onClickCopy: onClickCopy, onClickShow: onClickShow, onClickSlideClip: onClickSlideClip, slideFavoriteMap: slideFavoriteMap, slidePage: page })] })), _jsx(PdfImageModal, { children: _jsx(SlideModeFavoriteComponent, { onClickSlideClip: onClickSlideClip, slideFavoriteMap: slideFavoriteMap }) })] })));
    }
}
SlideOneShow.propTypes = {
    onClickCopy: propFunc().isRequired,
    onClickShow: propFunc().isRequired,
    onClickSlideClip: propFunc().isRequired,
    pageNo: propNumber().isRequired,
    pages: propArrayShape().isRequired,
    slideFavoriteMap: propShape().isRequired,
};
export default SlideOneShow;
